const date = new Date();
const year = date.getFullYear();
const month = date.getMonth();
const day = date.getDate();
const hour = date.getHours();

export default `${year}${month}${day}${hour}`;



// WEBPACK FOOTER //
// ./src/utils/timestamp.js